import React from 'react';

const PrivacyPolicyTemplate = () => {
	return (
		<React.Fragment>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">Privacy Policy</h3>
			</div>
			<div className="ReactModal__body ReactModal__body--privacy">
				<div className="spc--bottom--sml">
					<p className="spc--bottom--tny type--base type--wgt--bold type--color--text">Privacy Notice</p>
					<p className="spc--bottom--tny">
						Smart Shipped is committed to protecting the privacy and security of your personal information. This
						Privacy Notice explains how we collect, use, disclose, and safeguard your personal data when you visit our
						website, interact with our services, or engage with us in any other way. By using our services, you consent
						to the practices described in this notice.
					</p>
					<label className="display--b spc--bottom--tny type--base type--wgt--bold type--color--text">
						1. Information We Collect
					</label>
					<p className="spc--bottom--tny">We may collect various types of personal information, including:</p>
					<ul className="list--bullet spc--bottom--tny">
						<li>Contact Information: such as your name, email address, phone number, and mailing address.</li>
						<li>
							Account Information: if you create an account with us, we may collect your username, password, and other
							account details.
						</li>
						<li>
							Payment Information: when making a purchase, we may collect payment card details or other financial
							information.
						</li>
						<li>
							Usage Information: including your IP address, browser type, device information, operating system, and
							usage patterns on our website.
						</li>
						<li>
							Communication Information: any information you provide when contacting us, such as email content or
							messages.
						</li>
					</ul>
					<label className="display--b spc--bottom--tny type--base type--wgt--bold type--color--text">
						2. How We Use Your Information
					</label>
					<p className="spc--bottom--tny">We use your personal information for the following purposes:</p>
					<ul className="list--bullet spc--bottom--tny">
						<li>To provide and improve our services.</li>
						<li>To personalize your experience and deliver relevant content.</li>
						<li>To process transactions and fulfill orders.</li>
						<li>To communicate with you and respond to inquiries.</li>
						<li>To send you important updates, promotions, and newsletters.</li>
						<li>To detect and prevent fraudulent activities or security breaches.</li>
						<li>To comply with legal obligations.</li>
					</ul>
					<label className="display--b spc--bottom--tny type--base type--wgt--bold type--color--text">
						3. Information Sharing and Disclosure
					</label>
					<p className="spc--bottom--tny">We may share your personal information in the following circumstances:</p>
					<ul className="list--bullet spc--bottom--tny">
						<li>With our trusted service providers who assist in delivering our services.</li>
						<li>With business partners or affiliates to provide joint services or promotions.</li>
						<li>When required by law or to respond to legal processes.</li>
						<li>To protect our rights, property, or safety, and that of others.</li>
						<li>In connection with a merger, acquisition, or sale of our company assets. </li>
					</ul>
					<label className="display--b spc--bottom--tny type--base type--wgt--bold type--color--text">
						4. Data Security
					</label>
					<p className="spc--bottom--tny">
						We implement appropriate security measures to protect your personal information from unauthorized access,
						alteration, disclosure, or destruction. However, please be aware that no method of transmission over the
						internet or electronic storage is completely secure.
					</p>
					<label className="display--b spc--bottom--tny type--base type--wgt--bold type--color--text">
						5. Your Rights and Choices
					</label>
					<p className="spc--bottom--tny">
						You have the right to access, update, and correct your personal information. You may also have the right to
						request the deletion of your data, object to its processing, or withdraw your consent. Please contact us
						using the information provided below to exercise these rights.
					</p>
					<label className="display--b spc--bottom--tny type--base type--wgt--bold type--color--text">
						6. Third-Party Links
					</label>
					<p className="spc--bottom--tny">
						Our website may contain links to third-party websites or services. We are not responsible for the privacy
						practices or content of such external sites. We encourage you to review the privacy policies of those third
						parties before providing any personal information.
					</p>
					<label className="display--b spc--bottom--tny type--base type--wgt--bold type--color--text">
						7. Updates to this Privacy Notice
					</label>
					<p className="spc--bottom--tny">
						We may update this Privacy Notice periodically to reflect changes in our practices or legal requirements. We
						will post the updated notice on our website, and the revised version will be effective as of the date
						indicated in the notice.
					</p>
					<label className="display--b spc--bottom--tny type--base type--wgt--bold type--color--text">
						8. Contact Us
					</label>
					<p className="spc--bottom--tny">
						If you have any questions, concerns, or requests regarding this Privacy Notice or the handling of your
						personal information, please contact us at:
					</p>
					<p className="spc--bottom--tny">Smart Shipped</p>
					<p className="spc--bottom--tny">Address: 1980 Swarthmore Ave, Lakewood, NJ 08701</p>
					<p className="spc--bottom--tny">
						Email: <a href="scanship@smartshipped.com">scanship@smartshipped.com</a>
					</p>
					<p>Phone: 208-248-7900</p>
				</div>
			</div>
		</React.Fragment>
	);
};

export default PrivacyPolicyTemplate;
